import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';
import { useParams } from 'react-router-dom';

import { fetch_one, fetch_all } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

// @ts-ignore
import {ReactComponent as Arrow} from "../../img/Argenco_pijl_green_rgb.svg";

import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Stack,
} from '@mui/material';

import {
  Benefit as BenTile,
  Cta,
  Footer,
  Hero,
  Section,
} from '../../components/v2/custom';
import {
  BlockInfo,
  DarkGreenButton,
  IconButton,
  LightGreenButton,
  Page,
  TextButton,
  TransparentButton,
  Typography
} from '../../components/v2/styled';

import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {}

export const BenefitDetail: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();

  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [benefit, setBenefit] = useState<Ben>();
  const [alwaysShowButton, setAlwaysShowButton] = useState<boolean>(objectId === '8' || objectId === '16');

  const {
    data: pubBenefit,
    isLoading: pubBenefitLoading,
    // isError: adviceUploadsError,
    isSuccess: pubBenefitSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", "pub", "benefit", objectId],
    queryFn: () =>
      fetch_one<Ben>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'v2_benefit',
          fields: ['id', 'created_at', 'nw_timing', 'nw_discount_tag', 'nw_intro', 'discount_name', 'get_item'],
          id: objectId
        },
        undefined
      ),
    enabled: !!objectId && !login?.id,
  });
  const {
    data: fullBenefit,
    isLoading: fullBenefitLoading,
    // isError: adviceUploadsError,
    isSuccess: fullBenefitSuccess,
    refetch: fullBenefitRefetch,
  } = useQuery({
    queryKey: ["nw", "full", "benefit", objectId],
    queryFn: () =>
      fetch_one<Ben>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'v2_benefit',
          fields: ['id', 'created_at', 'nw_timing', 'nw_discount_tag', 'nw_intro', 'nw_what', 'nw_how', 'nw_when', 'nw_where', 'block_info', 'discount_name', 'get_item', 'has_codes', 'linked_code'],
          id: objectId
        },
        login
      ),
    enabled: !!objectId && !!login?.id,
  });

  const {
    data: benefits,
    // isLoading: adviceUploadsLoading,
    // isError: adviceUploadsError,
    isSuccess: benefitsSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", "rand_benefits", objectId],
    queryFn: () =>
      fetch_all<Ben>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'v2_benefit',
          fields: ['id', 'created_at', 'nw_timing', 'nw_discount_tag', 'discount_name', 'get_item'],
          per_page: 3,
          order: 'RAND() ASC',
          filter: {
            advanced: {
              enabled: 1,
              skip_id: objectId,
              for_lang: i18n.resolvedLanguage || 'nl'
            }
          }
        },
        undefined
      ),
    enabled: !!objectId,
  });






  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);
      fullBenefitRefetch();
      setAlwaysShowButton(false);
    },
  });








  const tableRow = (label: string, content: string, divider: boolean) => {
    return <>
      <Grid item xs={4} sx={{
        paddingTop: {
          xs: 1,
          md: 2,
          lg: 3
        },
        paddingBottom: {
          xs: 1,
          md: 2,
          lg: 3
        },
        paddingLeft: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography sx={{
          textTransform: 'uppercase',
          color: theme.palette.primary.light
        }}>{label}</Typography>
      </Grid>
      <Grid item xs={8} sx={{
        paddingTop: {
          xs: 1,
          md: 2,
          lg: 3
        },
        paddingBottom: {
          xs: 1,
          md: 2,
          lg: 3
        },
        paddingRight: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography variant="body1" html fuck_p_tags>{content}</Typography>
      </Grid>

      {!!divider && <Grid item xs={12}>
        <Divider />
      </Grid>}
    </>;
  }
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    if (!!pubBenefit && !fullBenefit) setBenefit(pubBenefit);
  }, [pubBenefit]);
  useEffect(() => {
    if (!!fullBenefit) setBenefit(fullBenefit);
  }, [fullBenefit]);
  useEffect(() => {
    setObjectId(params.id);
  }, [params.id]);

  return <Page>
    {!!benefit && <Hero
      children={<>
        <Typography variant="h1" sx={{
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{(benefit.discount_name || {})[i18n.resolvedLanguage || 'nl']}</Typography>
        {!!(benefit.nw_intro || {})[i18n.resolvedLanguage || 'nl'] && <Typography variant="subtitle1" sx={{
          color: theme.palette.primary.dark,
          marginTop: 4,
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{(benefit.nw_intro || {})[i18n.resolvedLanguage || 'nl']}</Typography>}
      </>}
    />}

    <Section normalPage>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <IconButton sx={{
            "& svg": {
              transform: "rotate(270deg)",
              width: '20px',
              marginTop: -1,
              marginLeft: -0.25
            },
            display: 'inline-block',
            marginRight: 'auto',
            height: '32px',
            width: '32px',
            paddingTop: '5px',
            backgroundColor: theme.palette.secondary.light,
          }} onClick={() => {
            navigate('/benefits');
          }}>
            <Arrow />
          </IconButton>
          <TextButton
            id="back_btn"
            label={t("nw.benefit.detail.back_cta")}
            path="/benefits"
            sx={{
              fontSize: '16px',
              textDecoration: 'underline',
              width: 'auto'
            }}
          />
        </Grid>
      </Grid>
    </Section>

    <Section normalPage>
      {!login?.id && <Cta sx={{
        position: 'relative',
        // position: 'absolute',
        // top: 300,
        // left: 0,
        zIndex: 1101,
        // maxWidth: '1100px',
        marginTop: '192px'
      }}>
        <Typography variant="h2" html fuck_p_tags sx={{textAlign: 'center'}}>{t("nw.section.not_logged_in.title")}</Typography>
        <Typography sx={{
          marginTop: {
            xs: 2,
            md: 3
          },
          textAlign: 'center'
        }} variant="body1" html fuck_p_tags>{t("nw.section.not_logged_in.text")}</Typography>

        <Box sx={{
          marginTop: 4,
          width: '100%',
          textAlign: {
            xs: 'left',
            md: 'center'
          }
        }}>
          <LightGreenButton
            id="sharing_login"
            label={t("nw.stock.transfer.sharing.cta_login")}
            // path={`/login?b=${objectId}`}
            onClick={() => {
              window.scrollTo(0, 0);
              navigate('/login', {state: {benefitId: objectId}});
            }}
            sx={{
              display: {
                xs: 'block',
                md: 'inline-flex'
              }
            }}
          />
          <TransparentButton
            id="sharing_register"
            label={t("nw.stock.transfer.sharing.cta_register")}
            sx={{
              marginLeft: {
                xs: 0,
                md: 2.5
              },
              marginTop: {
                xs: 2.5,
                md: 0
              }
            }}
            path="/first_time"
          />
        </Box>
      </Cta>}

      <Grid container spacing={2.5} sx={{
        filter: !login?.id ? 'blur(4px)' : 'blur(0)',
        position: 'relative',
        zIndex: 1100,
        marginTop: !login?.id ? '-550px' : 0
      }}>
        <Grid item xs={12}>
          <Box
            sx={{
              width: {
                xs: '100%',
                md: '100%',
                lg: '670px'
              },
              marginLeft: 'auto',
              marginRight: 'auto',
              backgroundColor: 'white'
            }}
          >
            <Grid container spacing={0}>
              {!login?.id && tableRow(t("nw.benefit.detail.table.what"), "Lorem ipsum", true)}
              {!login?.id && tableRow(t("nw.benefit.detail.table.where"), "Sit ipsum dolor lorem amet", true)}
              {!login?.id && tableRow(t("nw.benefit.detail.table.when"), "Lorem ipsum dolor", true)}
              {!login?.id && tableRow(t("nw.benefit.detail.table.how"), "Quandicus delorium dolor sit amet lorem ipsum dolor sit amet lorem ipsum dolor sit amet lorem ipsum dolor sit amet", false)}
              {!!login?.id && tableRow(t("nw.benefit.detail.table.what"), (benefit?.nw_what || {})[i18n.resolvedLanguage || 'nl'], true)}
              {!!login?.id && tableRow(t("nw.benefit.detail.table.where"), (benefit?.nw_where || {})[i18n.resolvedLanguage || 'nl'], true)}
              {!!login?.id && tableRow(t("nw.benefit.detail.table.when"), (benefit?.nw_when || {})[i18n.resolvedLanguage || 'nl'], true)}
              {!!login?.id && tableRow(t("nw.benefit.detail.table.how"), (benefit?.nw_how || {})[i18n.resolvedLanguage || 'nl'], false)}
            </Grid>
          </Box>
        </Grid>

        {!!login?.id && !!benefit && !!benefit.block_info && <Grid item xs={12} sx={{height: '40px'}}>
          {/* spacer */}
        </Grid>}
        {!!login?.id && !!benefit && !!benefit.block_info && <Grid item xs={12}>
          <BlockInfo blockInfo={benefit.block_info} />
        </Grid>}
        {!!login?.id && !!benefit && <Grid item xs={12} sx={{height:  !benefit.block_info ? '300px' : '40px'}}>
          {/* spacer */}
        </Grid>}



        {!!login && !!benefit && (!!benefit.has_codes || !!benefit.linked_code) && <>
          <Grid item xs={12}>
            <Box
              sx={{
                width: {
                  xs: '100%',
                  md: '100%',
                  lg: '670px'
                },
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: theme.palette.secondary.light,
                padding: 2,
                borderRadius: '10px'
              }}
            >
              {(!benefit.linked_code || alwaysShowButton) && <Typography variant="h3" sx={{marginBottom: 2}}>{t("nw.benefit.benefit_code.title.not_linked")}</Typography>}
              {!(!benefit.linked_code || alwaysShowButton) && <Typography variant="h3" sx={{marginBottom: 2}}>{t("nw.benefit.benefit_code.title.linked")}</Typography>}

              {(!benefit.linked_code || alwaysShowButton) && <>
                {!mutationCustomAction.isPending && <DarkGreenButton
                  onClick={() => {
                    // this.setState({link_loading: true}, () => {
                    //   this.link_benefit();
                    // });
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'v2_benefit',
                        class_action: 'custom_api_link_code',
                        id: objectId
                      }
                    });
                  }}
                  label={t("nw.benefit.benefit_code.cta.link")}
                  sx={{marginBottom: 1}}
                  id="cta"
                />}
                {!!mutationCustomAction.isPending && <CircularProgress />}
              </>}
              {!(!benefit.linked_code || alwaysShowButton) && <Typography variant="h2" sx={{fontWeight: 'bold'}}>{benefit.linked_code}</Typography>}
            </Box>
          </Grid>
          <Grid item xs={12} sx={{height:  !benefit.block_info ? '300px' : '40px'}}>
            {/* spacer */}
          </Grid>
        </>}





        {!login?.id && <Grid item xs={12} sx={{height: '300px'}}>
          {/* spacer */}
        </Grid>}

        {!!benefit?.get_item && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <img src={benefit?.get_item} style={{maxWidth: '670px', width: '100%', borderRadius: '10px'}} />
        </Grid>}
      </Grid>
    </Section>

    <Section normalPage>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <Typography variant="h2" html fuck_p_tags sx={{textAlign: 'center', marginBottom: 4, marginTop: 8}}>{t("nw.benefit.detail.more_benefits_title")}</Typography>
          <Typography variant="subtitle1" html fuck_p_tags sx={{textAlign: 'center'}}>{t("nw.benefit.detail.more_benefits_text")}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2} sx={{
            overflowX: 'auto',
          }}>
            {benefitsSuccess && benefits.map(benefit => <BenTile benefit={benefit} sx={{
              minWidth: {xs: '99%', md: '49%', lg: '32%'},
              maxWidth: {xs: '99%', md: '49%', lg: '32%'}
            }} />)}
          </Stack>
        </Grid>
      </Grid>
    </Section>

    <Footer normalPage />
  </Page>;
}

